var map = {
	"./1.png": 3617,
	"./2.png": 3618,
	"./3-plus.png": 3619,
	"./3.png": 3620
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 704;



//////////////////
// WEBPACK FOOTER
// ./assets/images/ribbons/numbers .\.png*
// module id = 704
// module chunks = 0